export default __webpack_public_path__ + "static/media/clock.da8ba8e0.png";